import { t } from '../../../../locale';
import { FlowInterface } from '../flow-interface';
import { generateBuyLink, generatePlanCategory } from '../../helper/utils';
import { planTypes } from '../../constant';

export default class BuyTrial extends FlowInterface {
  getCurrentParams() {
    return {
      ...this.getBuyNowParams(),
      plan: planTypes.ZOOM_SCHEDULER,
      from: generatePlanCategory(planTypes.ZOOM_SCHEDULER),
    }
  }

  getLink() {
    return generateBuyLink(this.getCurrentParams());
  }

  getOptions() {
    return {
      disabled: !this.productEntryData?.currentUserHasPermission,
      buttonTitle: t('billing.product.entry_free_trial.buy'),
    };
  }
}
